module.exports = __webpack_public_path__ + "img/wikipedia-w.d3663bb8.svg";